import {of as observableOf, Subject, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {UiChangesPreventionDialogComponent} from '../../shared/modals/ui-changes-prevention-dialog/ui-changes-prevention-dialog.component';


@Injectable({providedIn: 'root'})
export class ProductSetupChangesService {

  public hasChanges = false;

  // notify component  when changes are discarded
  private subject = new Subject<any>();
  private popSub = new Subject<boolean>();


  dialogRef: MatDialogRef<UiChangesPreventionDialogComponent>;

  constructor(private dialog: MatDialog) {
  }


  continueWithoutChanges(): Observable<boolean> {
    if (this.hasChanges) {
      this.openDialog();
      return this.popSub.asObservable();
    } else {
      return observableOf(true);
    }
  }

  openDialog() {
    this.dialogRef = this.dialog.open(UiChangesPreventionDialogComponent, {
      disableClose: false,
      autoFocus: false
    });
    this.dialogRef.componentInstance.userActions.subscribe(flag => {
      if (flag.data) {
        this.hasChanges = false;
        this.subject.next();
      }
      this.popSub.next(flag.data);
    });
  }

  discardChanges(): Observable<any> {
    return this.subject.asObservable();
  }

  applyDiscardedChanges(group: FormGroup, formValues:any){
    this.applyFormValues(group, formValues);
  }

  private applyFormValues (group: FormGroup, formValues:any) {
    Object.keys(formValues).forEach(key => {
      let formControl = <FormControl>group.controls[key];
      if (formControl instanceof FormGroup) {
        this.applyFormValues(formControl, formValues[key]);
      } else {
        formControl.setValue(formValues[key]);
      }
    });
  }

  readFormValues (group: FormGroup, formValues: any) {
    Object.keys(formValues).forEach(key => {
      let formControl = <FormControl>group.controls[key];
      if (formControl instanceof FormGroup) {
        this.applyFormValues(formControl, formValues[key]);
      } else {
        formValues[key] =  formControl.value;
      }
    });
  }

  compareFormChanges(source: any, comapreWith: any) {
    let hasValueChanges: boolean = false;
    Object.keys(source).forEach(key => {
      let item = source[key];
      if (item instanceof Object) {
        hasValueChanges = hasValueChanges || this.compareFormChanges(item, comapreWith[key]);
      } else {
        let temp: boolean = source[key] != comapreWith[key] &&  comapreWith[key] != undefined;
        if (source[key]  == null && comapreWith[key] == '')
          temp = false;
        //console.log(source[key] + ": " + comapreWith[key])
        hasValueChanges = hasValueChanges || temp;
      }
    });

    return hasValueChanges;
  }

}
